import { AtBeforeInputValidation } from '@/models/BcxForm';

const useBeforeInput = () => {
  /**
   * Executes all before-input validation functions for an input event.
   */
  const handleBeforeInputFunctions = (event: InputEvent, atBeforeInput: AtBeforeInputValidation[]) => {
    atBeforeInput.forEach((fn: AtBeforeInputValidation) => fn(event));
  };

  /**
   * Prevents input of characters not matching the given pattern.
   */
  const validatePattern = (pattern: string) => (event: InputEvent) => {
    if (
      pattern
      && event.data
      && new RegExp(`[^${pattern}]`, 'u').test(event.data)
    ) {
      event.preventDefault();
    }
  };

  return { validatePattern, handleBeforeInputFunctions };
};

export default useBeforeInput;
